import * as Yup from 'yup';
import { countryCodes } from '@/helpers/countries';

export default Yup.object().shape({
  firstname: Yup.string()
    .required('Este campo es requerido')
    .matches(/^[a-zA-Z0-9À-ú ]+$/i, 'Solo se permiten valores alfanuméricos'),
  lastname: Yup.string()
    .required('Este campo es requerido')
    .matches(/^[a-zA-Z0-9À-ú ]+$/i, 'Solo se permiten valores alfanuméricos'),
  email: Yup.string()
    .email('Escriba una dirección de correo válida')
    .required('Este campo es requerido'),
  mobilephone: Yup.string()
    .required('Este campo es requerido')
    .matches(
      /^(?=.*[0-9])[+()0-9 ]+$/i,
      'Solo se permiten números de teléfonos válidos'
    ),
  city: Yup.string()
    .required('Este campo es requerido')
    .matches(/^[a-zA-Z0-9À-ú ]+$/i, 'Solo se permiten valores alfanuméricos'),
  country: Yup.string()
    .required('Debe seleccionar un país')
    .oneOf(countryCodes(), 'Solo se permite un código de dos letras válido'),
  website: Yup.string().notRequired(),
});
